module.exports = __webpack_public_path__ + "img/rep-brittney.8c5c0008.png";